import type { ContextValue } from '../../components/SunriseHoldoutExperimentContextProvider';

import type { EnabledState } from './enabledState';
import type { VariantState } from './variantState';

export type IsSunriseEnabledProps = {
	isSunriseEnabled: boolean;
};

export type IsSunriseEnabledState = IsSunriseEnabledProps & EnabledState & VariantState;

export function isSunriseEnabledState({
	enabled,
	isSunriseEnabled,
	variant,
}: {
	enabled: boolean;
	isSunriseEnabled: boolean;
	variant: ContextValue['variant'];
}): IsSunriseEnabledState {
	return {
		enabled,
		isSunriseEnabled,
		variant,
	};
}
